export default function genererMaterielNumerique() {
  return {
    timeLoop: 60,
    spotNumber: 6,
    timeSpot: 10,
  };
}
